const REGION_TO_ISO: Record<string, string> = {
  France: "FR",
  Germany: "DE",
  England: "GB",
  Scotland: "GB",
  Wales: "GB",
  "United Kingdom": "GB",
  Italy: "IT",
  Spain: "ES",
  Netherlands: "NL",
  Switzerland: "CH",
  Belgium: "BE",
  Austria: "AT",
  Portugal: "PT",
  Sweden: "SE",
  Norway: "NO",
  Denmark: "DK",
  Finland: "FI",
  Ireland: "IE",
  Luxembourg: "LU",
  Greece: "GR",
  Poland: "PL",
  "Czech Republic": "CZ",
  Hungary: "HU",
  Romania: "RO",
  Turkey: "TR",
  Russia: "RU",
  Ukraine: "UA",
  "United States": "US",
  Canada: "CA",
  Mexico: "MX",
  Brazil: "BR",
  Argentina: "AR",
  Chile: "CL",
  Colombia: "CO",
  Peru: "PE",
  China: "CN",
  Japan: "JP",
  "South Korea": "KR",
  India: "IN",
  Singapore: "SG",
  "Hong Kong": "HK",
  Australia: "AU",
  "New Zealand": "NZ",
  "South Africa": "ZA",
  "United Arab Emirates": "AE",
  "Saudi Arabia": "SA",
  Israel: "IL",
  Egypt: "EG",
  Nigeria: "NG",
  Kenya: "KE",
  Thailand: "TH",
  Malaysia: "MY",
  Indonesia: "ID",
  Philippines: "PH",
  Vietnam: "VN",
  Taiwan: "TW",
};

export function countryFlag(name: string): string | null {
  const iso = REGION_TO_ISO[name];
  if (!iso) return null;
  return String.fromCodePoint(...iso.split("").map(c => 0x1f1e6 + c.charCodeAt(0) - 65));
}
